import React from 'react';
import Modal from 'components/new_ui/Modal/Modal';

import { Accordion } from 'react-bootstrap5';

import { useNavigate, useParams } from 'react-router-dom';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import useChooseStepTopics from 'components/Common/Programs/Hooks/useChooseStepTopics';
import useStep from 'components/Common/Programs/Hooks/useStep';

import Title from './Title';
import Body from './Body';

export default function Index() {
  const navigate = useNavigate();
  const { stepId } = useParams();
  const topics = useChooseStepTopics(stepId);
  const step = useStep(stepId);

  return (
    <Modal
      show
      header={<h3>Change Topic</h3>}
      onHide={() => navigate(-1, { preventScrollReset: true })}
    >
      {(topics === null || step === null) && <LoadingPlaceholder text="Loading..." />}

      {topics && step && (
        <Accordion>
          {step.attributes.topic && (
            <>
              <h4>Current Topic</h4>

              <Accordion.Item
                key="current-topic"
                eventKey="current-topic"
              >
                <Accordion.Header>
                  <Title title={step.attributes.topic.title} icon={step.attributes.topic.icon} />
                </Accordion.Header>

                <Accordion.Body>
                  <Body
                    stepId={stepId}
                    topicId={step.attributes.topic.id}
                    enableChoose={false}
                    description={step.attributes.topic.description}
                  />
                </Accordion.Body>
              </Accordion.Item>
            </>
          )}

          {topics.map((item) => (
            <React.Fragment key={item.category}>
              <h4 className="mt-3">{item.category}</h4>

              {item.topics.map((topic) => (
                <Accordion.Item
                  key={`topic-${topic.id}`}
                  eventKey={`topic-${topic.id}`}
                >
                  <Accordion.Header>
                    <Title title={topic.attributes.title} icon={topic.attributes.icon} />
                  </Accordion.Header>

                  <Accordion.Body>
                    <Body
                      stepId={stepId}
                      topicId={topic.id}
                      enableChoose
                      description={topic.attributes.description}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </React.Fragment>
          ))}
        </Accordion>
      )}
    </Modal>
  );
}
